/* eslint-disable no-restricted-syntax -- 알림 API 가 내려주고 받는 한국어 원문 값. 비교·전송에만 쓰고 화면에는 t() 로 매핑해 보여준다 */

/** PATCH /alert/(bio|emergency|falldetection)/:id 요청 바디의 type */
export enum AlertPatchType {
    ASSIGN = '담당자 배정',
    CONFIRM = '확인 완료'
}

/** 대상자 성별 원문 */
export enum AlertProtecteeGender {
    MALE = '남',
    FEMALE = '여'
}

/** nameDetail.hrateStatus / respStatus 원문 */
export enum AlertVitalStatus {
    NORMAL = '정상',
    STABLE = '안정',
    UNSTABLE = '불안정',
    LOW = '낮음',
    HIGH = '높음'
}

/** 알림 처리 상태 배지가 구분하는 '확인' 원문 (EmergencyAlertConfirmStatus 에는 없는 값) */
export const ALERT_CONFIRM_CHECKED = '확인'

/* eslint-enable no-restricted-syntax */
